import React from 'react';
import glamorous from 'glamorous';
import { IconClasses, Icon } from '@blueprintjs/core';

const GpcMoreInfo = () => {
  return (
    <div>
      <h3>
        MORE INFORMATION ON GPC CODES
      </h3>
      <br/>
      <div>
        <p>Detailed information on GPC codes is available <i>via</i> the following links:</p>
        <glamorous.Ul
          className="pt-list"
          css={{
            listStyle: 'disc',
          }}
        >
          <li>
            <a href="http://www.gs1.org/docs/gpc/GPC_Development_Implementation.pdf" target="_blank">
              http://www.gs1.org/docs/gpc/GPC_Development_Implementation.pdf <Icon iconName={IconClasses.SHARE}/>
            </a>
          </li>
          <li>
            <a href="http://www.gs1.org/1/productssolutions/gdsn/gpc/browser/index.html" target="_blank">
              http://www.gs1.org/1/productssolutions/gdsn/gpc/browser/index.html <Icon iconName={IconClasses.SHARE}/>
            </a>
          </li>
        </glamorous.Ul>
      </div>
    </div>
  );
};

export default GpcMoreInfo;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/gpc-more-info.js